import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CollaborateurService } from '@shared/services/cabinet/collaborateur.service';
import { DossierService } from '@shared/services/cabinet/dossier.service';
import { PreferenceService } from '@shared/services/cabinet/preference.service';

export const collabGuard: CanActivateFn = () => {
  const router = inject(Router);
  const collaborateurService = inject(PreferenceService);
  const dossierService = inject(DossierService);
  return collaborateurService.isCollab
    ? true
    : router.navigate([`dossier/${dossierService.dossierId}/accueil`]);
};
